import { useState, useEffect } from 'react'
import { Input } from 'antd-mobile'
import { t } from '@/utils/i18n'
import { utils } from '@/utils'
import Icon from '@/components/Icon/Icon'
import IconClose from '@/assets/img/icon/close.svg'
import styles from './index.module.less'

const { debounce, onClickSevalTimes, initVConsole } = utils

interface SearchBarProps {
  customizeStyle?: any
  placeholder?: string
  text?: string
  onSearch?: (searchText: string) => void
  onScan?: (text: string) => void
  className?: string
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = t('搜索'),
  text = '',
  onSearch = () => {},
  onScan = () => {},
  className,
  customizeStyle,
}) => {
  const [searchText, setSearchText] = useState(text)
  const style = {
    backgroundColor: '#f0f0f0',
    ...customizeStyle,
  }

  const canScan = window.webview && window.webview.scan

  // 重置搜索
  const handleResetSearch = (e: any) => {
    e.stopPropagation()
    setSearchText('')
  }

  const handleSearch = debounce(() => {
    onSearch(searchText)
  }, 150)

  useEffect(() => {
    handleSearch()
  }, [searchText])

  const handleScan = async () => {
    // 唤起 app 扫码
    if (window.webview && window.webview.scan) {
      window.webview.scan()
    }
  }

  // 获取 App 扫码结果
  const getScanValue = (text: string) => {
    onScan(text)
    setSearchText(text)
    onSearch(text)
  }

  window.getScanValue = getScanValue

  const onClickSixTimes = onClickSevalTimes(function () {
    initVConsole()
  }, 6)

  return (
    <div
      className={`${styles['search-bar']} ${className}`}
      onClick={onClickSixTimes}
    >
      <div className={styles['bd']} style={style}>
        <div className={styles['title-search']}>
          <Icon name="search" color="#7f7f7f" size="40" />

          <Input
            className={styles['title-search-input']}
            type="text"
            placeholder={placeholder}
            value={searchText}
            onChange={setSearchText}
          />

          {searchText && (
            <img
              className={styles['title-search-close']}
              src={IconClose}
              onClick={handleResetSearch}
              title="close"
            />
          )}

          {canScan && (
            <Icon name="scan" color="#7f7f7f" size="40" onClick={handleScan} />
          )}
        </div>
      </div>
    </div>
  )
}

export default SearchBar
